import React, { useState } from "react";
import { Button, Tooltip, Typography } from "@material-ui/core";
import {
  Add as AddIcon,
  Delete as DeleteIcon,
  Edit as EditIcon,
} from "@material-ui/icons";
import CustomTextField from "../../Shared/CustomTextField/CustomTextField";
import "../styles/ReasonManager.scss";

const ReasonManager = ({ reasons, onChange }) => {
  const [newReason, setNewReason] = useState("");
  const [editIndex, setEditIndex] = useState(-1);
  const [error, setError] = useState("");

  const handleAddReason = () => {
    if (!newReason.trim()) {
      setError("Reason cannot be empty");
      return;
    }

    if (reasons.includes(newReason.trim())) {
      setError("This reason already exists");
      return;
    }

    if (editIndex >= 0) {
      // Edit existing reason
      const updatedReasons = [...reasons];
      updatedReasons[editIndex] = newReason.trim();
      onChange(updatedReasons);
      setEditIndex(-1);
    } else {
      // Add new reason
      onChange([...reasons, newReason.trim()]);
    }

    setNewReason("");
    setError("");
  };

  const handleDeleteReason = (index) => {
    const updatedReasons = reasons.filter((_, i) => i !== index);
    onChange(updatedReasons);

    // If deleting the reason being edited, clear the edit state
    if (index === editIndex) {
      setEditIndex(-1);
      setNewReason("");
    }
  };

  const handleEditReason = (index) => {
    setNewReason(reasons[index]);
    setEditIndex(index);
    setError("");
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleAddReason();
    }
  };

  const handleInputChange = (e) => {
    setNewReason(e.target.value);
    if (e.target.value.trim()) {
      setError("");
    }
  };

  return (
    <div className="reason-manager-container">
      <div className="reason-input-section">
        <CustomTextField
          value={newReason}
          onChangeValue={(e) => handleInputChange(e)}
          label={editIndex >= 0 ? "Edit Reason" : "Add Reason"}
          fieldKey="newReason"
          placeholder={
            editIndex >= 0
              ? "Edit reason"
              : "Type at least one reason and press Add"
          }
          inputLabelShrink={true}
          error={error}
          onKeyPress={handleKeyPress}
          style={{ boxShadow: "none", backgroundColor: "#F0F5FA" }}
          isRequired
        />

        <div className="reason-button-container">
          <button
            className="add-button"
            onClick={handleAddReason}
            disabled={!newReason.trim()}
          >
            {editIndex >= 0 ? "Update" : "Add"}
          </button>

          {editIndex >= 0 && (
            <button
              className="cancel-button"
              onClick={() => {
                setEditIndex(-1);
                setNewReason("");
                setError("");
              }}
            >
              Cancel
            </button>
          )}
        </div>
      </div>

      {error && <div className="error-message">{error}</div>}

      <div className="reasons-list">
        {reasons.length === 0 ? (
          <Typography
            variant="body2"
            color="textSecondary"
            className="no-reasons-message"
          >
            No reasons added yet. At least one reason is required. Type reason
            in the field and press Add.
          </Typography>
        ) : (
          reasons.map((reason, index) => (
            <div key={index} className="reason-item">
              <span className="reason-text">{reason}</span>
              <div className="reason-actions">
                <Tooltip title="Edit">
                  <button
                    className="action-button edit-button"
                    onClick={() => handleEditReason(index)}
                  >
                    <EditIcon
                      fontSize="small"
                      style={{ color: "rgb(101 102 101)" }}
                    />
                  </button>
                </Tooltip>
                <Tooltip title="Delete">
                  <button
                    className="action-button delete-button"
                    onClick={() => handleDeleteReason(index)}
                  >
                    <DeleteIcon
                      fontSize="small"
                      style={{ color: "rgb(101 102 101)" }}
                    />
                  </button>
                </Tooltip>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default ReasonManager;
